import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { message } from "antd";

import { CiCircleChevLeft } from "react-icons/ci";

import { AuthAction } from "../../store/actions";

import LoginLayout from "../../components/layouts/login-layout";
import { Buttons, Spacer, inputFields, loginAndSignup } from "../../components";

import { Images } from "../../config";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const handleForgot = () => {
    if (!email) {
      message.error("Email can not be left empty.");
    } else {
      const body = {
        email,
      };
      dispatch(
        AuthAction.ForgotPassword(body, (res) => {
          if (res.status === 200) {
            navigate("/verify-otp", { state: { email } });
          }
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleForgot();
    }
  };

  return (
    <LoginLayout>
      <div className="flex flex-col items-center justify-center px-[6.25em] py-[3.75em] bg-login-gradient gap-4">
        <div className="relative">
          <CiCircleChevLeft
            className="text-[2.5em] absolute -left-[3.725em] top-1 cursor-pointer"
            onClick={() => {
              window.history.back();
            }}
          />
          <img src={Images.UnivisionLogoWithText} className="h-[3.75em]" />
        </div>
        <Spacer height={5} />
        <div className="flex flex-col gap-2 justify-center items-center">
          <div className="text-main font-bold text-[2.5em]">
            Forgot Password
          </div>
          <div className="text-[1.375em] font-semibold">
            Enter email to send OTP
          </div>
        </div>
        <div className="flex flex-col gap-2 w-[28.125em]">
          <loginAndSignup.LoginInputTitle title="Email Address" />
          <inputFields.DefaultInput
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            onKeyDown={handleKeyDown}
            placeholder="xyz@abc.com"
          />
          <Spacer height={10} />
          <Buttons.DefaultButton onClick={handleForgot} width="full">
            Continue
          </Buttons.DefaultButton>
        </div>
      </div>
    </LoginLayout>
  );
};

export default ForgotPassword;
